import script from "./fenxi.vue?vue&type=script&setup=true&lang=js"
export * from "./fenxi.vue?vue&type=script&setup=true&lang=js"

import "./fenxi.vue?vue&type=style&index=0&id=4395a716&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4395a716"]])

export default __exports__